export default __webpack_public_path__ + "static/media/house_alert.936e04e1.png";